import { styled } from '@mui/material/styles';
import MuiDialogContent from '@mui/material/DialogContent';

export const DialogContent = styled(MuiDialogContent, {
  shouldForwardProp: prop => prop !== 'padding' && prop !== 'overflowX'
})(({ theme, padding, overflowX }) => ({
  boxSizing: 'border-box',
  padding: padding ? padding : `${theme.spacing(3)} ${theme.spacing(3)}`,
  minHeight: '230px',
  ...(overflowX && {
    overflowX: overflowX
  })
}));
